import React, { useState, useEffect } from "react";
import "./ourservice.css";
import { Modal } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { leaf_right, tooth } from "../../assets/images/images";

const services = [
  // Ayurvedic Services
  { 
    id: 1, 
    name: "Panchakarma Therapy", 
    icon: "🌿", 
    type: "AYURVEDA",
    description: "Traditional detoxification and rejuvenation therapy for holistic wellness",
    benefits: ["Detoxification", "Stress Relief", "Immune Boost", "Energy Restoration"]
  },
  { 
    id: 2, 
    name: "Herbal Medicine", 
    icon: "🪴", 
    type: "AYURVEDA",
    description: "Natural healing through ancient herbal formulations and remedies",
    benefits: ["Natural Healing", "No Side Effects", "Holistic Approach", "Long-term Wellness"]
  },
  { 
    id: 3, 
    name: "Yoga Therapy", 
    icon: "🧘", 
    type: "AYURVEDA",
    description: "Therapeutic yoga practices for physical and mental well-being",
    benefits: ["Flexibility", "Mental Clarity", "Stress Reduction", "Body-Mind Balance"]
  },
  { 
    id: 4, 
    name: "Diet Consultation", 
    icon: "🥗", 
    type: "AYURVEDA",
    description: "Personalized dietary plans based on Ayurvedic principles",
    benefits: ["Personalized Plans", "Digestive Health", "Weight Management", "Energy Optimization"]
  },
  
  // Dental Services
  { 
    id: 5, 
    name: "General Dentistry", 
    icon: "🪥", 
    type: "DENTAL",
    description: "Comprehensive dental care including cleanings, fillings, and preventive treatments",
    benefits: ["Preventive Care", "Cavity Treatment", "Oral Hygiene", "Regular Checkups"]
  },
  { 
    id: 6, 
    name: "Orthodontics", 
    icon: "🦷", 
    type: "DENTAL",
    description: "Advanced teeth straightening and bite correction treatments",
    benefits: ["Teeth Alignment", "Bite Correction", "Confidence Boost", "Oral Health"]
  },
  { 
    id: 7, 
    name: "Cosmetic Dentistry", 
    icon: "✨", 
    type: "DENTAL",
    description: "Smile enhancement through advanced cosmetic dental procedures",
    benefits: ["Smile Makeover", "Teeth Whitening", "Veneers", "Natural Results"]
  },
  { 
    id: 8, 
    name: "Pediatric Dentistry", 
    icon: "👶", 
    type: "DENTAL",
    description: "Specialized dental care for children in a friendly, comfortable environment",
    benefits: ["Child-Friendly", "Early Prevention", "Gentle Care", "Education"]
  },
];

function Ourservices() {
  const [selectedService, setSelectedService] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [animateServices, setAnimateServices] = useState(false);

  const ayurvedaServices = services.filter((service) => service.type === "AYURVEDA");
  const dentalServices = services.filter((service) => service.type === "DENTAL");

  useEffect(() => {
    // Trigger animation when component mounts
    const timer = setTimeout(() => setAnimateServices(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const handleClick = (service) => {
    setSelectedService(service);
    setModalVisible(true);
  };

  const renderServices = (services, delay = 0) => {
    return services.map((service, index) => (
      <div
        key={service.id}
        className={`service-card ${animateServices ? 'animate-in' : ''}`}
        style={{ animationDelay: `${delay + index * 0.15}s` }}
        onClick={() => handleClick(service)}
      >
        <div className="service-icon-container">
          <div className="service-icon">
            <span>{service.icon}</span>
          </div>
          <div className="service-glow"></div>
        </div>
        <div className="service-content">
          <h4 className="service-title">{service.name}</h4>
          <p className="service-description">{service.description}</p>
          <div className="service-benefits">
            {service.benefits.slice(0, 1).map((benefit, idx) => (
              <span key={idx} className="benefit-tag">{benefit}</span>
            ))}
          </div>
        </div>
        <div className="service-hover-effect"></div>
      </div>
    ));
  };

  return (
    <section className="services-section" id="services">
      <div className="services-background">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>
      
      <div className="container">
        <div className="services-header">
          <img src={leaf_right} alt="leaf" className="leaf-decoration left-leaf" />
          <img src={tooth} alt="tooth" className="tooth-decoration right-tooth" />
          
          <div className="header-content">
            <h2 className="section-title">OUR SERVICES</h2>
            <p className="section-subtitle">Comprehensive healthcare solutions combining ancient wisdom with modern expertise</p>
          </div>
        </div>

        <div className="services-grid">
          <div className="service-category dental">
            <div className="category-header">
              <div className="category-icon">🦷</div>
              <h3 className="category-title">DENTAL CARE</h3>
              <p className="category-description">Advanced dental treatments for all ages</p>
            </div>
            <div className="services-carousel">
              <Slider {...settings}>
                {renderServices(dentalServices, 0.6)}
              </Slider>
            </div>
          </div>
          <div className="service-category ayurveda">
            <div className="category-header">
              <div className="category-icon">🌿</div>
              <h3 className="category-title">AYURVEDIC MEDICINE</h3>
              <p className="category-description">Holistic healing through traditional Indian medicine</p>
            </div>
            <div className="services-carousel">
              <Slider {...settings}>
                {renderServices(ayurvedaServices, 0.3)}
              </Slider>
            </div>
          </div>
        </div>
      </div>

      <Modal show={modalVisible} onHide={() => setModalVisible(false)} centered className="service-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="modal-title-content">
              <span className="modal-icon">{selectedService?.icon}</span>
              <span>{selectedService?.name}</span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="service-details">
            <p className="service-full-description">{selectedService?.description}</p>
            
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default Ourservices;
